class CartToast extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  render() {
    this.innerHTML = `
      <div class="toast-container" id="toast-container" role="alert" aria-live="polite">
        <div class="toast-message">
          <span id="toast-text" class="label-s">Added to cart</span>
        </div>
        <button class="toast-action-btn label-s" id="toast-open-cart-btn" type="button">Open Cart</button>
      </div>
    `;

    this.container = this.querySelector("#toast-container");
    this.openCartBtn = this.querySelector("#toast-open-cart-btn");

    if (this.openCartBtn) {
      this.openCartBtn.addEventListener("click", () => {
        // this.dispatchEvent(new CustomEvent("open-cart", { bubbles: true }));
        if (window.openCart) {
          window.openCart();
        }
        this.hide();
      });
    }
  }

  show(message = "Added to cart", anchorEl = null) {
    if (this.timeoutId) clearTimeout(this.timeoutId);

    const textElem = this.querySelector("#toast-text");
    if (textElem) textElem.textContent = message;

    if (anchorEl) {
      const rect = anchorEl.getBoundingClientRect();
      const targetTop = rect.top + rect.height / 2;
      const targetLeft = Math.min(rect.right + 12, window.innerWidth - 240);
      this.style.top = `${targetTop}px`;
      this.style.left = `${targetLeft}px`;
    }

    if (this.container) {
      void this.container.offsetWidth;
      this.container.classList.add("is-visible");
    }

    this.timeoutId = setTimeout(() => {
      this.hide();
    }, 4000);
  }

  hide() {
    if (this.timeoutId) clearTimeout(this.timeoutId);
    if (this.container) {
      this.container.classList.remove("is-visible");
    }
  }
}

customElements.define("cart-toast", CartToast);
